<template lang="html">
  <div class="main">
    <SoundslidesPlayer
      v-if="showData"
      :path_to_assets="pathToImages"
      :editing_initial_slide_data="showData.slideArray"
      :editing_audio_source_url="audioUrl"
      :use-show-dimensions="true"
      :solo-player="true"
      class="center"
    />
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "Preview",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {
    }
  },
  computed:{
    id(){
      return this.$route.params.id;
    },
    showData(){
      return this.$store.getters.getShowById(this.id);
    },
    audioUrl(){
      return this.showData.show_url + "/" + this.showData.audio.filename
    },
    pathToImages(){
      return this.showData.show_url + "/"
    }
  },
  mounted(){
    this.$store.dispatch("loadShows");
  }
}
</script>

<style lang="css" scoped>
.main{
  position: absolute;
  width: 100%;
  height: 100%;
}
.center{
  position: relative;
  top: 33%;
  left: 50%;
  transform: translateX(-50%) translateY(-33%);
  max-width: 100%;
  max-height: 100%;
}
</style>
